import styles from './Loader.module.scss';

const LoaderVariant = {
  BeatLoader: 'BeatLoader',
  MoonLoader: 'MoonLoader',
} as const;

type LoaderVariant = (typeof LoaderVariant)[keyof typeof LoaderVariant];

type LoaderProps = {
  /**
   * @deprecated Retained for backward compatibility; the spinner is now CSS-driven and this prop is a no-op.
   */
  variant?: LoaderVariant;
  size?: number;
};

export function Loader({ size }: LoaderProps) {
  const style = size !== undefined ? { width: `${size}px`, height: `${size}px` } : undefined;

  return (
    <div className={styles.loader} style={style} aria-label="Loading Spinner" data-testid="loader" role="status" />
  );
}
